import React from "react";
import { Link, useLocation } from "react-router-dom";

const Sidebar = () => {
  const location = useLocation();
  const path = location.pathname;

  const menuItems = [
    { label: "Dashboard", path: "/dashboard" },
    { label: "Projects", path: "/projects" },
    { label: "Tasks", path: "/tasks" },
    { label: "Bugs", path: "/bugs" },
    { label: "Payments", path: "/payments/overdue" },
    { label: "Skills", path: "/skills" },
  ];

  const isActive = (menuPath) =>
    path === menuPath || path.startsWith(`${menuPath}/`);

  return (
    <aside className="w-64 h-screen sticky top-0 bg-white border-r p-6">
      <h2 className="text-2xl font-bold mb-6">ClientDock</h2>

      <ul className="space-y-2">
        {menuItems.map((item) => (
          <li key={item.path}>
            <Link
              to={item.path}
              className={`block px-4 py-2 rounded-lg transition ${
                isActive(item.path)
                  ? "bg-blue-600 text-white"
                  : "text-gray-700 hover:bg-gray-100"
              }`}
            >
              {item.label}
            </Link>
          </li>
        ))}
      </ul>
    </aside>
  );
};

export default Sidebar;
